export const documentsOptions = [
	{ code: "aKhatha", name: "A khatha" },
	{ code: "occupancyCertificate", name: "Occupancy Certificate" },
	// { code: "bKhatha", name: "B khatha" },
	// { code: "bKhathaLand", name: "B khatha Land" },
];
